import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ProductTileContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import { useProductTileClickImpressions } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import { usePreloadNavigationToPDP } from "@faire/retailer-visitor-shared/views/product/preload/preloadNavigationToPDP";
import React, { useCallback } from "react";
export var useOnProductClickBase = function(params) {
    var _React_useContext = React.useContext(ProductTileContext), recordAdImpression = _React_useContext.recordAdImpression, brand = _React_useContext.brand, brandToken = _React_useContext.brandToken;
    var recordProductTileClickEvent = useProductTileClickImpressions(params, brandToken !== null && brandToken !== void 0 ? brandToken : brand === null || brand === void 0 ? void 0 : brand.token, recordAdImpression).recordProductTileClickEvent;
    var preloadNavigationToPDP = usePreloadNavigationToPDP();
    return useCallback(function() {
        recordProductTileClickEvent();
        var _params_images;
        preloadNavigationToPDP(_object_spread_props(_object_spread({}, params), {
            showVerticalImagery: params.showVerticalImagery,
            productToken: params.token,
            bestImage: params.bestImage,
            images: (_params_images = params.images) !== null && _params_images !== void 0 ? _params_images : [],
            brandToken: brandToken !== null && brandToken !== void 0 ? brandToken : brand === null || brand === void 0 ? void 0 : brand.token
        }));
    }, [
        recordProductTileClickEvent,
        params,
        preloadNavigationToPDP,
        brandToken,
        brand === null || brand === void 0 ? void 0 : brand.token
    ]);
};
